import type { DialogDesignTokens } from '@primeuix/themes/types/dialog'
import type { DrawerDesignTokens } from '@primeuix/themes/types/drawer'
import type { PopoverDesignTokens } from '@primeuix/themes/types/popover'

import { bothSchemes } from '../utils'

/**
 * Bottom sheet — основной оверлей мини-аппа (выбор филиала, оценка заказа,
 * «Добавить в корзину», «Очистить»). Радиус верхних углов и safe-area —
 * в styles/primevue.scss, у Drawer нет токена borderRadius.
 */
export const drawerConfig = (): DrawerDesignTokens => ({
  header: {
    padding: 'var(--space-8) var(--space-8) var(--space-4)',
  },
  title: {
    fontSize: '20px',
    fontWeight: 'var(--fw-bold)',
  },
  content: {
    padding: '0 var(--space-8) var(--space-8)',
  },
  footer: {
    padding: '0 var(--space-8) var(--space-8)',
  },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-card)',
      borderColor: 'transparent',
      color: 'var(--text-color)',
      shadow: 'var(--shadow-card)',
    },
  }),
})

/** Модальные окна используем редко — только подтверждения. */
export const dialogConfig = (): DialogDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-xl)',
    shadow: 'var(--shadow-card)',
  },
  header: { padding: 'var(--space-8)', gap: 'var(--space-4)' },
  title: { fontSize: '20px', fontWeight: 'var(--fw-bold)' },
  content: { padding: '0 var(--space-8) var(--space-8)' },
  footer: { padding: '0 var(--space-8) var(--space-8)', gap: 'var(--space-4)' },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-card)',
      borderColor: 'transparent',
      color: 'var(--text-color)',
    },
  }),
})

/** Popover-подсказка про баллы (270x128 в макете). */
export const popoverConfig = (): PopoverDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-l)',
    shadow: 'var(--shadow-card)',
    gutter: '8px',
  },
  content: {
    padding: 'var(--space-6)',
  },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-inverse)',
      borderColor: 'transparent',
      color: 'var(--text-color-inverse)',
    },
  }),
})
